export const FEATURE_FLAG_ORG_WIDE_RANKING_CHARTS =
  'prod-dev-health-dashboard-org-wide-ranking-charts';

export const PROD_DEV_DASHBOARD_QUALITY_POSTURE =
  'prod-dev-health-dashboard-quality-posture';
